export default "__VITE_ASSET__DY8dipN5__"